import { gql } from '@apollo/client'

export const createOfferMutation = gql`
  mutation createOffer($offerInput: Credit_BusinessCredit_CreateOfferInput!) {
    credit {
      businessCredit {
        createOffer(input: $offerInput) {
          offer {
            id
            formattedTerm {
              formattedTimeDuration(formatOptions: { style: LONG, unit: DAY })
            }
            formattedAmount {
              amount(formatOptions: { style: SYMBOL })
            }
            formattedAverageMonthlyCost {
              amount(formatOptions: { style: SYMBOL })
            }
            formattedAnnualPercentageRate {
              percentage
            }
          }
        }
      }
    }
  }
`

export const acceptOfferMutation = gql`
  mutation acceptOffer(
    $acceptOfferInput: Credit_BusinessCredit_AcceptOfferInput!
  ) {
    credit {
      businessCredit {
        acceptOffer(input: $acceptOfferInput) {
          offerId
        }
      }
    }
  }
`
